import styled from 'styled-components/macro';
import * as colors from '../../../common/colorConstants';
import { mediumHeightScreens, smallScreens } from '../../../common/fontElements';

const SearchResultsContainer = styled.div`
  display: flex;
  flex-grow: 1;
`;

const HeaderContainer = styled.div`
  padding: 30px 40px 30px;
  border-bottom: 1px solid ${colors.lightGray15};
  @media (max-height: ${smallScreens}) {
    padding: 20px 40px 20px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    padding: 10px 40px 15px;
  }
`;

const Title = styled.p`
  font-family: Lato;
  font-size: 14px;
  color: ${colors.darkGray9};
  margin: 0px;
  @media (max-height: ${smallScreens}) {
    font-size: 12px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    font-size: 11px;
  }
`;

const SubTitle = styled.p`
  font-family: Lato;
  font-size: 14px;
  color: ${colors.darkGray9};
  margin: 0px;
  @media (max-height: ${smallScreens}) {
    font-size: 12px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    font-size: 11px;
  }
`;

const ResultsSection = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const SearchOrdersBox = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;

  & > * {
    padding: 5px;
    flex: 1 0;
  }
`;

const SearchInputContainer = styled.div`
  width: 50%;
  margin: 10px 10px 0px 0px;
  padding: 0px;
  flex-basis: 30%;
  @media (max-width: ${smallScreens}) {
    flex-basis: 100%;
  }
`;

const SpaceHolder = styled.div`
  height: 0px;
  margin: 0px;
  padding: 0px;
  flex-basis: 30%;
  @media (max-width: ${smallScreens}) {
    flex-basis: 100%;
  }
`;

const Container = styled.div`
  position: relative;
  height: 100%;
  flex-direction: column;
  display: flex;
`;

// scroll container
const SearchOrderContent = styled.div`
  flex: 1;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
  flex-direction: column;
`;

// scroll child
const SearchAndResults = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
`;

const NoResultsWrapper = styled.div`
  height: 10px;
  padding: 40px;
`;

const ResultsTable = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 300px;
`;

const ResultsHeader = styled.p`
  color: ${colors.darkGray9};
  font-family: lato, sans-serif;
  line-height: 1.8rem;
  width: 100%;
  margin: 20px 0px 20px 10px;
  @media (max-height: ${smallScreens}) {
    font-size: 12px;
    margin: 10px 0px 10px 10px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    font-size: 11px;
    margin: 10px 0px 10px 10px;
  }
`;

export {
  SearchResultsContainer,
  HeaderContainer,
  Title,
  SubTitle,
  ResultsSection,
  SearchOrdersBox,
  SearchInputContainer,
  SpaceHolder,
  Container,
  SearchOrderContent,
  SearchAndResults,
  NoResultsWrapper,
  ResultsTable,
  ResultsHeader,
};
